/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { VbzInputText, VbzButton } from '@smiles/voebiz-ui-kit';
import { useTranslation } from 'react-i18next';
import ReCAPTCHA from 'react-google-recaptcha';
import queryString from 'query-string';

import { regexPhoneFormatter } from '../../utils';
import validateEmailChange from '../../utils/validateEmail';
import { STRING_VALIDATE, CELLPHONE_VALIDATE } from '../../constants';

type Props = {
  recaptchaKey: string;
  setFirstName: (...args: any[]) => any;
  setEmail: (...args: any[]) => any;
  setPhoneNumber: (...args: any[]) => any;
  setRecaptchaValue: (...args: any[]) => any;
  firstName: string;
  email: string;
  phoneNumber: string;
  recaptchaValue: string;
  onSubmit: (...args: any[]) => any;
  isLoading: boolean;
};

const defaultValues = {
  solicitationType: '',
  subject: 'Clube Smiles para Empresas',
  message: '',
  email: '',
  firstName: '',
  lastName: '',
  voebizCode: '',
  phoneNumber: '',
};

const ProporsalForm = ({
  recaptchaKey,
  setFirstName,
  setEmail,
  setPhoneNumber,
  setRecaptchaValue,
  firstName,
  email,
  phoneNumber,
  recaptchaValue,
  onSubmit,
  isLoading,
}: Props) => {
  const [btnDisabled, setBtnDisabled] = useState<boolean>(true);
  const [emailValid, setEmailValid] = useState<boolean>(false);
  const { t } = useTranslation('company_proposal');
  const recComponent = useRef<any>();

  const urlParams = useMemo(() => queryString.parse(window.location.search), []);

  useEffect(() => {
    const hasValidData =
      firstName && emailValid && phoneNumber && (recaptchaValue?.length > 1 || urlParams.bpr === '1');
    const buttonDisabled = !!hasValidData;
    setBtnDisabled(!buttonDisabled);
  }, [firstName, emailValid, phoneNumber, recaptchaValue]);

  const handleSubmit = () => {
    onSubmit({ ...defaultValues, firstName, email, phoneNumber });
  };

  const RecaptchaHandleChange = (e: any) => {
    setRecaptchaValue(e);
  };

  const emailHandleChange = (value: any) => {
    const isMailValid = validateEmailChange(value);
    setEmailValid(isMailValid);
    setEmail(value);
  };

  return (
    <div className="vbz-proposal-form" data-testid="vbz-proposal-form">
      <form>
        <VbzInputText
          className="vbz-proposal-input"
          placeholder={t<string>('name_place_holder')}
          textLabel={t<string>('name_label')}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
          regex={STRING_VALIDATE}
          value={firstName}
          data-testid="vbz-input-name"
        />
        <VbzInputText
          className="vbz-proposal-input"
          placeholder={t<string>('email_place_holder')}
          textLabel={t<string>('email_label')}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => emailHandleChange(e?.target?.value?.trim())}
          value={email}
          data-testid="vbz-input-email"
        />
        <VbzInputText
          className="vbz-proposal-input"
          placeholder={t<string>('cellphone_place_holder')}
          textLabel={t<string>('cellphone_label')}
          maxLength={15}
          minLength={14}
          regex={CELLPHONE_VALIDATE}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPhoneNumber(regexPhoneFormatter(e.target.value))}
          value={phoneNumber}
          data-testid="vbz-input-cellPhone"
        />
        <div data-testid="vbz-proposal-recaptcha">
          <ReCAPTCHA
            ref={recComponent}
            size="normal"
            onExpired={() => setRecaptchaValue('')}
            sitekey={recaptchaKey}
            onChange={RecaptchaHandleChange}
          />
        </div>
        <VbzButton
          text={t<string>('button_label')}
          onClick={handleSubmit}
          disabled={btnDisabled}
          isLoading={isLoading}
          className="vbz-proposal-btn"
          data-testid="vbz-proposal-btn"
        />
      </form>
    </div>
  );
};

export default ProporsalForm;
